export const WINDOW_RESIZE = 'WINDOW_RESIZE',
    WINDOW_SCROLL = 'WINDOW_SCROLL';

export function windowResize() {
    return {type: WINDOW_RESIZE};
};

export function windowScroll() {
    return {type: WINDOW_SCROLL};
};


// WEBPACK FOOTER //
// ./src/actions/viewport.js